import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const StyledStorageInfo = styled.div``;

export const StyledLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledLabel = styled.h3`
  color: ${themeGet('colors.text.tertiary')};
  font-size: ${themeGet('fontSizes.xxs')}px;
  font-weight: ${themeGet('fontWeights.regular')};
  line-height: ${themeGet('lineHeights.body')};
`;

export const StyledValue = styled.p`
  color: ${themeGet('colors.primary.extra')};
  font-size: ${themeGet('fontSizes.up')}px;
  font-weight: ${themeGet('fontWeights.semiBold')};
  line-height: ${themeGet('lineHeights.body')};
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;

  & button {
    padding: 3px 12px;
  }
`;
